import React, { Component } from "react";

export default class Textarea extends Component {
  state = { isTextareaTouched: false, isTextareaFocused: false };
  componentDidMount() {
    document.addEventListener("click", this.handleClick, false);
  }
  componentWillUnmount() {
    document.removeEventListener("click", this.handleClick, false);
  }
  handleClick = event => {
    if (this.textarea) {
      if (this.textarea.contains(event.target)) {
        this.setState({ isTextareaFocused: true });
        if (this.textarea.querySelector) {
          this.textarea.querySelector("textarea").focus();
        }
      } else {
        this.setState({ isTextareaFocused: false });
      }
    }
  };
  onFocusHandler = event => {
    const { isTextareaTouched } = this.state;
    if (!isTextareaTouched) {
      this.setState({ isTextareaTouched: true });
    }
  };
  render() {
    const { isTextareaFocused, isTextareaTouched } = this.state;
    const {
      placeholder,
      className,
      value,
      disabled,
      readOnly,
      onChange,
      label,
      onClear,
      error,
      info
    } = this.props;
    let _classes = ["form-group", "form-group-custom", "form-control-clear"];
    if (isTextareaFocused) {
      _classes.push("active");
    }
    if (!label) {
      _classes.push("form-control-clear-no-head");
    }
    return (
      <div
        className={_classes.join(" ")}
        ref={element => (this.textarea = element)}
      >
        {label ? <label>{label}</label> : null}
        <div class="form-control-clear-wrap">
          <textarea
            rows="3"
            className={
              className
                ? ["form-control"].concat(className).join(" ")
                : "form-control"
            }
            value={value}
            disabled={disabled}
            readOnly={readOnly}
            onChange={event => {
              event.preventDefault();
              onChange(event.target.value);
            }}
            placeholder={placeholder}
            onFocus={this.onFocusHandler}
          />
          {readOnly || disabled ? null : onClear ? (
            <a class="form-control-clear-button" onClick={onClear}>
              <span class="glyphicon glyphicon-remove" />
            </a>
          ) : null}
        </div>
        {error && isTextareaTouched ? (
          <span className="help-block">{error}</span>
        ) : info ? (
          <span className="help-block">{info}</span>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/_components/UI/Textarea/index.js